/*
  do not include any tsx files
*/
import { UserRole } from '@briq/shared/src/utils/types'

export enum Routes {
  Home = 'Home',
  Profile = 'Profile',
  ProfileManagement = 'ProfileManagement',
  Accounting = 'Accounting',
  Transactions = 'Transactions',
  ArchiveReports = 'ArchiveReports',
  ArchiveNotifications = 'ArchiveNotifications',
  ArchiveInvoices = 'ArchiveInvoices',
  Activation = 'AccountActivation',
  Search = 'Search',
  CompanyDetail = 'CompanyDetail',
  Investigation = 'Investigation',
  Cart = 'Cart',
  PasswordReset = 'PasswordReset',
  PasswordUpdate = 'PasswordUpdate',
  Register = 'Register',
  Checkout = 'Checkout',
  Billing = 'Billing',
  Payment = 'Payment',
  Confirmation = 'Confirmation',
  OrderProcessing = 'OrderProcessing',
  UploadImport = 'UploadImport',
  Import = 'Import',
  ImportHistory = 'ImportHistory'
}

export const DISABLED_LOGIN_CALLBACK_ROUTES = [
  Routes.Checkout,
  Routes.Billing,
  Routes.Confirmation,
  Routes.Payment,
  Routes.Activation
]

export type RouteConfig = Record<
  Routes | string,
  | {
      sensitive?: boolean
      strict?: boolean
      localizationKey?: string
      authorized?: boolean
      requiredRole?: UserRole
      includeInSitemap?: boolean
      excludeFromRouter?: boolean
      ssr?: boolean
    }
  | undefined
>

export const routesConfig: RouteConfig = {
  [Routes.Home]: {
    localizationKey: '/'
  },
  [Routes.Profile]: {
    authorized: true
  },
  [Routes.ProfileManagement]: {
    authorized: true
  },
  [Routes.ArchiveReports]: {
    authorized: true
  },
  [Routes.ArchiveInvoices]: {
    authorized: true
  },
  [Routes.Activation]: {
    authorized: false
  },
  [Routes.Accounting]: {
    authorized: true
  },
  [Routes.Transactions]: {
    authorized: true
  },
  [Routes.ArchiveNotifications]: {
    authorized: true
  },
  [Routes.Search]: {},
  [Routes.CompanyDetail]: {
    ssr: true
  },
  [Routes.Investigation]: {
    authorized: true
  },
  [Routes.Cart]: {
    authorized: true
  },
  [Routes.PasswordReset]: {
    authorized: false
  },
  [Routes.PasswordUpdate]: {
    authorized: false
  },
  [Routes.Register]: {
    authorized: false,
    includeInSitemap: true
  },
  [Routes.OrderProcessing]: {
    authorized: true
  },
  [Routes.Checkout]: {
    authorized: true
  },
  [Routes.Confirmation]: {
    authorized: true,
    excludeFromRouter: true
  },
  [Routes.Billing]: {
    authorized: true,
    excludeFromRouter: true
  },
  [Routes.Payment]: {
    authorized: true,
    excludeFromRouter: true
  },
  [Routes.UploadImport]: {
    authorized: true,
    requiredRole: UserRole.BRIQBulkImport
  },
  [Routes.Import]: {
    authorized: true,
    requiredRole: UserRole.BRIQBulkImport
  },
  [Routes.ImportHistory]: {
    authorized: true,
    requiredRole: UserRole.BRIQBulkImport
  }
}
